import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function ForYou() {
  const points = ['Querés empezar a trabajar con deportistas y sentís que te falta estructura.', 'Ya atendés deportistas, pero tus sesiones a veces se vuelven conversaciones sueltas.', 'Te cuesta saber qué preguntar en la primera sesión.', 'Querés sentir más seguridad profesional al ofrecer servicios de psicología deportiva.'];
  return <section className="bg-slate-50 py-12 md:py-20" data-id="element-89">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-90">
        <div className="mx-auto max-w-3xl" data-id="element-91">
          <h2 className="mb-8 md:mb-12 text-center text-2xl text-slate-900 md:text-4xl font-display" data-id="element-92">
            ESTE KIT ES PARA VOS SI...
          </h2>

          <div className="grid gap-3 md:gap-4 sm:grid-cols-2" data-id="element-93">
            {points.map((point, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.05
          }} className="flex items-start gap-3 rounded-xl bg-white p-4 md:p-6 border border-slate-200 shadow-sm" data-id="element-94">
                <CheckCircle2 className="h-5 w-5 shrink-0 text-emerald-500" data-id="element-95" />
                <p className="text-xs md:text-sm text-slate-700 font-medium leading-relaxed" data-id="element-96">
                  {point}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}